export default Object.freeze({
    Single: 0,
    Multi: 1,
});
